import { render, staticRenderFns } from "./px-stage-status-item.vue?vue&type=template&id=ca900b7e&scoped=true&"
import script from "./px-stage-status-item.vue?vue&type=script&lang=ts&"
export * from "./px-stage-status-item.vue?vue&type=script&lang=ts&"
import style0 from "./px-stage-status-item.vue?vue&type=style&index=0&id=ca900b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca900b7e",
  null
  
)

export default component.exports